"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { isLandingPath } from "@/lib/landing-paths";

/**
 * Компонент для управления классом body в зависимости от страницы
 * Для лендинга убираем site-bg, для остальных страниц добавляем
 */
export default function LandingBodyClass() {
  const pathname = usePathname();
  
  // Check if we're on landing page (served at / and /about; middleware rewrites to /landing)
  const isLandingPage = isLandingPath(pathname);

  useEffect(() => {
    if (isLandingPage) {
      // Для лендинга убираем site-bg и устанавливаем темный фон
      document.body.classList.remove("site-bg");
      document.body.style.backgroundColor = "#0E0E0E";
      document.body.style.color = "#ffffff";
    } else {
      // Для терминала добавляем site-bg
      document.body.classList.add("site-bg");
      document.body.style.backgroundColor = "";
      document.body.style.color = "";
    }

    // Cleanup при размонтировании
    return () => {
      document.body.style.backgroundColor = "";
      document.body.style.color = "";
    };
  }, [isLandingPage, pathname]);

  return null;
}
